import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';

import { Image } from '@hydra/common/components';

import phoneBackgroundImageUrl from '@hydra/assets/img/review/bg-iphone-portrait-grey.svg';
import tabletBackgroundImageUrl from '@hydra/assets/img/review/bg-ipad-landscape-grey.svg';
import desktopBackgroundImageUrl from '@hydra/assets/img/review/bg-dashboard-screen-fback.svg';

function getBackgroundImg (type) {
  switch (type) {
    case 'phone': return phoneBackgroundImageUrl;
    case 'tablet': return tabletBackgroundImageUrl;
    case 'desktop':
    case 'xlDesktop':
      return desktopBackgroundImageUrl;
    default: return null;
  }
}

const useStyles = makeStyles(theme => ({
  phone: {
    width: '94px',
    height: '200px',
    paddingTop: '20px',
    paddingLeft: '4px'
  },
  phoneImg: {
    width: '86px',
    maxHeight: '152px',
    minHeight: '111px'
  },
  tablet: {
    width: '284px',
    height: '200px',
    paddingTop: '14px',
    paddingLeft: '24px'
  },
  tabletImg: {
    width: '240px',
    maxHeight: '172px'
  },
  desktop: {
    width: '220px',
    height: '177px',
    paddingTop: '8px',
    paddingLeft: '8px'
  },
  desktopImg: {
    width: '202px'
  },
  xlDesktop: {
    width: '420px',
    height: '362px',
    paddingTop: '15px',
    paddingLeft: '15px'
  },
  xlDesktopImg: {
    width: '388px'
  }
}));

export const Screenshot = ({
  src,
  type = 'phone',
  className,
  width,
  height,
  defer,
  ...props
}) => {
  const classes = useStyles();
  return (
    <div
      className={classnames(classes[type], className)}
      style={{ background: `url(${getBackgroundImg(type)}) top left no-repeat` }}
    >
      <Image
        src={src}
        className={classes[`${type}Img`]}
        width={width}
        height={height}
        defer={defer}
        {...props}
      />
    </div>
  );
};

Screenshot.propTypes = {
  className: PropTypes.string,
  type: PropTypes.oneOf(['phone', 'tablet', 'desktop', 'xlDesktop']),
  src: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  defer: PropTypes.bool
};

export default Screenshot;
